import { Icon, Text } from '@pukka/ui-components';

interface ReceiptBusinessInfoProps {
  readonly businessName?: string | null;
  readonly outletAddress?: string | null;
  readonly outletName?: string | null;
  readonly outletPhone?: string | null;
}

export default function ReceiptBusinessInfo({ businessName, outletName, outletAddress, outletPhone }: ReceiptBusinessInfoProps) {
  return (
    <div className="mb-4 text-center">
      <div>
        <Text variant="title-2" weight="semibold">
          {businessName}
        </Text>
        {outletName && <Text weight="semibold">{outletName}</Text>}
        <Text variant="body-1">{outletAddress}</Text>
        <Text variant="body-1">
          <Icon icon="call" size="sm" /> {outletPhone}
        </Text>
      </div>
    </div>
  );
}
